import {TableHeaderDataInterface} from "../../../components/table/TableHeaderUI";

export const headerData = [
  {
    label: "STATUS",
    widthPercentage: "8%",
    align: "center",
  },
  {
    label: "QUESTION",
    widthPercentage: "62%",
    align: "left",
  },
  {
    label: "DIFFICULTY",
    widthPercentage: "15%",
    align: "center",
  },
  {
    label: "TIME TAKEN",
    widthPercentage: "15%",
    align: "center",
  },
] as TableHeaderDataInterface[];
